import {
  generatedApi,
  type GetReservedPeriodsApiArg,
} from "src/store/api/generatedApi";
import type { AppDispatch } from "src/store/store";

export const refreshReservedPeriods = async (
  dispatch: AppDispatch,
  args: GetReservedPeriodsApiArg
) => {
  await dispatch(
    generatedApi.util.getRunningQueryThunk("getReservedPeriods", args)
  );
  await dispatch(
    generatedApi.endpoints.getReservedPeriods.initiate(args, {
      forceRefetch: true,
      subscribe: false,
    })
  );
};
